import { useEffect, useRef, useState } from "react";
import { Reorder, useDragControls } from "framer-motion";
import { toast } from "sonner";
import { GripVertical, ChevronUp, ChevronDown } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { refreshUi } from "@/lib/uiConfig";

function Row({ item, on, onDrop, onMove, first, last }) {
  const controls = useDragControls();
  const arrow = "w-8 h-8 shrink-0 rounded-xl flex items-center justify-center text-slate-400 hover:bg-rose-50 hover:text-rose-500 disabled:opacity-30";
  return (
    <Reorder.Item value={item.id} dragListener={false} dragControls={controls} onDragEnd={onDrop} data-testid={`feed-order-item-${item.id}`}
      className={`flex items-center gap-3 p-3 rounded-2xl border text-sm select-none ${on ? "bg-white border-pink-100 shadow-sm" : "bg-slate-50 border-slate-100 text-slate-400"}`}
      whileDrag={{ scale: 1.03, boxShadow: "0 12px 30px rgba(225,29,99,.25)" }}>
      <button type="button" onPointerDown={(e) => controls.start(e)} style={{ touchAction: "none" }} aria-label="Ziehen zum Sortieren" data-testid={`feed-order-handle-${item.id}`}
        className="w-9 h-9 -m-1 shrink-0 rounded-xl flex items-center justify-center text-rose-400 hover:bg-rose-50 cursor-grab active:cursor-grabbing"><GripVertical className="w-5 h-5" /></button>
      <span className="flex-1 font-semibold">{item.label}</span>
      {!on && <span className="text-[11px] font-bold uppercase tracking-wider">aus</span>}
      <button type="button" disabled={first} onClick={() => onMove(-1)} aria-label="Nach oben" data-testid={`feed-order-up-${item.id}`} className={arrow}><ChevronUp className="w-4 h-4" /></button>
      <button type="button" disabled={last} onClick={() => onMove(1)} aria-label="Nach unten" data-testid={`feed-order-down-${item.id}`} className={arrow}><ChevronDown className="w-4 h-4" /></button>
    </Reorder.Item>
  );
}

export function FeedOrderAdmin({ items, shown }) {
  const cards = items.filter((i) => i.optin);
  const [order, setOrder] = useState(null);
  const latest = useRef([]);
  useEffect(() => {
    api.get("/admin/ui-visibility").then(({ data }) => {
      const o = data.order || [];
      setOrder([...o.filter((id) => cards.some((c) => c.id === id)), ...cards.map((c) => c.id).filter((id) => !o.includes(id))]);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { latest.current = order || []; }, [order]);
  const save = async () => {
    try { await api.put("/admin/ui-order", { order: latest.current }); refreshUi(); toast.success("Reihenfolge gespeichert"); }
    catch (e) { toast.error(formatErr(e)); }
  };
  if (!order) return null;
  return (
    <div className="space-y-2" data-testid="feed-order-admin">
      <p className="text-xs font-bold uppercase tracking-wider text-rose-500">Reihenfolge im Feed</p>
      <p className="text-xs text-slate-500">Zieh die Karten am Griff in die gewünschte Reihenfolge oder nutze die Pfeile. Ausgeschaltete Karten behalten ihren Platz für später.</p>
      <Reorder.Group axis="y" values={order} onReorder={setOrder} className="space-y-2">
        {order.map((id, i) => <Row key={id} item={cards.find((c) => c.id === id)} on={shown.includes(id)} onDrop={save} first={i === 0} last={i === order.length - 1}
          onMove={(d) => { const o = [...order]; [o[i], o[i + d]] = [o[i + d], o[i]]; setOrder(o); latest.current = o; save(); }} />)}
      </Reorder.Group>
    </div>
  );
}
